<template>
  <div>
    <a-breadcrumb>
      <a-breadcrumb-item>系统设置</a-breadcrumb-item>
      <a-breadcrumb-item>项目管理</a-breadcrumb-item>
      <a-breadcrumb-item v-if="tagType == 'company'">公司标签</a-breadcrumb-item>
      <a-breadcrumb-item v-if="tagType == 'notes'">notes标签</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="space-20">
      <span>标签：</span>
      <a-input v-model="key" style="width:300px" placeholder="标签名称"></a-input>
      <a-button @click="handleTagAction('add')" type="primary" class="gap-10" :disabled="!key">添加</a-button>
    </div>
    <div>
      <a-spin :spinning="loading">
        <draggable v-model="list" :options="{ animation: 150 }" @end="handleTagSort" group="tags" class="space-20">
          <transition-group>
            <a-tag
              @click.self="
                showModel = 'editTag';
                current = v;
              "
              @close="handleDelete($event, v)"
              class="m-sm"
              v-for="v in list"
              :key="v.id"
              closable
            >
              {{ v.name }}
            </a-tag>
          </transition-group>
        </draggable>
      </a-spin>
    </div>
    <a-modal title="编辑标签" :visible="showModel == 'editTag'" width="400px" :footer="null" @cancel="hideModel">
      <a-input-search v-model="current.name" @search="handleTagAction('edit')">
        <a-button slot="enterButton" type="primary">确认</a-button>
      </a-input-search>
    </a-modal>
  </div>
</template>
<script>
import { tagList, tagSort, tagDelete, tagAction } from '@/api/tags';
import draggable from 'vuedraggable';
export default {
  components: { draggable },
  data() {
    return {
      showModel: '',
      loading: true,
      list: [],
      key: '',
      current: {}
    };
  },
  computed: {
    tagType() {
      return this.$route.params.type;
    }
  },
  watch: {
    tagType() {
      this.getTagList();
    }
  },
  methods: {
    hideModel() {
      this.showModel = '';
    },
    getTagList() {
      this.loading = true;
      tagList(this.tagType).then(res => {
        this.list = res.data;
        this.loading = false;
      });
    },
    handleDelete(e, v) {
      e.preventDefault();
      this.$confirm({
        title: `确定删除标签：${v.name}吗`,
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          tagDelete(this.tagType, { tagId: v.id }).then(res => {
            if (res.code === 200) {
              this.$message.success(res.data);
              this.getTagList();
            }
          });
        }
      });
    },
    handleTagSort() {
      let list = this.list.map(item => item.id);
      tagSort(this.tagType, { tagIdList: list.join(',') }).then(res => {
        if (res.code === 200) {
          this.$message.success(res.data || 'success');
        }
      });
    },
    handleTagAction(action) {
      let data;
      action === 'add' && (data = { name: this.key });
      action === 'edit' && (data = { name: this.current.name, id: this.current.id });
      tagAction(this.tagType, data).then(res => {
        if (res.code === 200) {
          this.$message.success(res.data || 'success');
          this.getTagList();
          action === 'edit' && this.hideModel();
          action === 'add' && (this.key = '');
        }
      });
    }
  },
  mounted() {
    this.getTagList();
  }
};
</script>
